import type {
  ConfirmDeletionRequest,
  ConfirmDeletionResult,
  RequestDeletionRequest,
} from '@/types/accountDeletion.types';

import { apiClient } from './api.service';

/**
 * Both endpoints are unauthenticated by design — Play requires a deletion path usable by
 * someone who has already uninstalled the app. Ownership is proved by the emailed code.
 */
export const accountDeletionApi = {
  request: (body: RequestDeletionRequest): Promise<null> =>
    apiClient.post<null>('/account-deletion/request', body).then((r) => r.data),

  confirm: (body: ConfirmDeletionRequest): Promise<ConfirmDeletionResult> =>
    apiClient.post<ConfirmDeletionResult>('/account-deletion/confirm', body).then((r) => r.data),
};
